<template>
  <div>
    <!-- Word版分享的时候的方案选择 -->
    <el-dialog :style="{ '--left': left}" style="margin-top: -10vh" class="productTypeDialog planWordDialog"
               :before-close="closeDialog" :destroy-on-close="true" :close-on-click-modal="false" :append-to-body="true"
               title=""
               :visible.sync="schemeShow" width="500px">
      <div class="Dialog-top">
        <span class="schemeSharing">方案分享</span>
      </div>
      <div class="Radio-Before Export-Item">
        <!--                <span style="font-size: 14px;font-weight: bolder;">请选择导出项：</span>-->
        <el-radio-group class="Export-Item-Radio top-radio" v-model="exportType" @change="exportTypeChange">
          <el-radio :label="0">
            团组报价单
          </el-radio>
          <el-radio :label="1">
            团组确认书
          </el-radio>
          <el-radio :label="2">
            出团说明书
          </el-radio>
        </el-radio-group>
      </div>

      <div class="Bottom-Style">
        <span style="font-size: 14px;font-weight: 300">请选择所需显示的内容</span>
        <div class="Left-Line"></div>
        <div style="padding-left:20px">
          <div class="Radio-Before Export-Item">
            <div style="padding-bottom: 10px;padding-top: 5px;">
              <el-checkbox style="color: #DB4E1A" :indeterminate="checkItemContent.programme.isIndeterminate"
                           class="checkBox"
                           v-model="checkItemContent.programme.checkAll" @change="handleCheckProgrammeAllChange"
                           disabled>
                <svg-icon class="iconExport" icon-class="exportAdd"></svg-icon>
                方案
                <span style="color: #339900;font-size: 12px;display: inline-block;transform: scale(0.8);">可多选</span>
              </el-checkbox>
              <el-checkbox-group
                  style="
                                height: 0.8rem;
                                display: flex;
                                flex-wrap: wrap;
                                align-items: center;
                                border-radius: 10px;
                                padding-left: 2px;
                           "
                  v-model="checkItemContent.programme.checkProgrammeItems"
                  @change="handleCheckedProgrammeChange">
                <el-checkbox style="width: 75px" v-for="item in checkItemContent.programme.programmeArr" :label="item"
                             :key="item">
                  {{
                    item === 0 ? '单人' : item === 1 ? '总价' : item === 2 ? '个人信息' : item === 3 ? '公司信息'
                        : item === 4 ? '行程地图' : item === 5 ? '特色推荐' : item === 6 ? '参考酒店' : item === 7 ? '参考餐厅' : '简要信息'
                  }}
                </el-checkbox>
              </el-checkbox-group>
              <span style="position: relative;top: 3.5px;color: #DB4E1A" v-if="tweetCount==0"><i
                  class="el-icon-warning-outline" style="padding-right: 2px"></i>该方案没有设置特推图<a @click="goSet"
                                                                                                        style="text-decoration: underline;color: #0A56BB">去添加</a></span>
              <span style="position: relative;top: 3.5px;color: #DB4E1A" v-else><i class="el-icon-warning-outline"
                                                                                   style="padding-right: 2px"></i>已有特推图<a
                  @click="goSet" style="text-decoration: underline;color: #0A56BB">去修改</a></span>
            </div>

            <div>
              <el-checkbox :indeterminate="checkItemContent.offer.isIndeterminate"
                           class="checkBox"
                           style="color: #DB4E1A"
                           v-model="checkItemContent.offer.checkAll" @change="handleCheckOfferAllChange" disabled>
                <svg-icon class="iconExport" icon-class="exportAdd"></svg-icon>
                报价
                <span style="color: #339900;font-size: 12px;display: inline-block;transform: scale(0.8);">可多选</span>
              </el-checkbox>
              <el-checkbox-group
                  style="
                                height: 30px;
                                display: flex;
                                align-items: center;
                                padding-left: 2px;
                                border-radius: 10px;
                           "
                  v-model="checkItemContent.offer.checkOfferItems"
                  @change="handleCheckedOfferChange">
                <el-checkbox v-for="item in checkItemContent.offer.offerArr" :label="item" :key="item">
                  {{ item === 2 ? '单价' : item === 1 ? '总价' : '单人' }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="applets-style" style="margin-top: 6px">
            <div class="Radio-Before">
                            <span style="font-size: 12px;font-weight: bolder;">
                             <svg-icon class="iconExport" icon-class="exportAdd"></svg-icon>
                                说明
                                <span
                                    style="color: #339900;font-size: 12px;display: inline-block;transform: scale(0.8);">单选</span>
                            </span>
              <!--                    <span style="font-size: 12px;font-weight: 200;">（点击名称查看展示效果）</span>-->
              <span @click="handlerOrganizationSetClick" type=""
                    style="text-decoration: underline;display: inline-block;transform: scale(0.8);border-radius: 10px;color: rgb(219, 78, 26);">点击新增</span>
            </div>
            <el-radio-group v-model="schemeRadio" class="custom-radio" @change="changeRadio">
              <el-radio v-for="(item,index) in schemeData" @click.native.prevent="changeRadio(item.id)" :label="item.id"
                        :key="index">{{ item.schemeName }}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="Radio-Before">
            <svg-icon class="iconExport" icon-class="exportAdd"></svg-icon>
            <el-link style="font-size: 12px;font-weight: bolder;" @click="preview">点击预览</el-link>
          </div>
          <div class="Radio-Before Export-Item-File">
            <svg-icon class="iconExport bigIcon" icon-class="exportRight"></svg-icon>
            <div class="Item-File">
              <div>
                <Qr :text="text"></Qr>
                <span style="display: flex;justify-content: center;margin-top: 5px;font-weight: 700">扫描查看手机版本</span>
              </div>
              <div>
                <el-radio-group class="Export-Item-Radio-Download" v-model="itemFileType" @change="versionExport">
                  <el-radio style="width: 230px" v-for="(item,index) in exportContent[exportType].itemFileTypeArr"
                            :key="index" :label="item.value">
<!--                    <i class="el-icon-upload"></i>-->
                    <svg style="position: relative;top: 6px;" t="1728568808301" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5156" width="200" height="200"><path d="M833.841473 336.403925c-29.237791-149.914232-160.920736-263.309448-321.841473-263.309448S219.452762 186.489692 190.158527 336.403925C80.48859 365.641715 0 468.030427 0 585.038033c0 142.633006 113.395216 256.028222 255.971778 256.028222h36.57546v-73.15092h-36.57546c-102.388711 0-182.877301-80.432146-182.877301-182.877302 0-102.388711 80.432146-182.877301 182.877301-182.877301 0-142.633006 113.395216-255.971778 255.971778-255.971778 142.633006 0 256.028222 113.395216 256.028222 255.971778 102.388711 0 182.877301 80.432146 182.877301 182.877301 0 102.388711-80.432146 182.877301-182.877301 182.877302h-36.57546v73.15092h36.57546c142.633006 0 255.971778-113.395216 255.971778-256.028222 0.056444-117.007607-80.432146-219.396318-190.102083-248.634108z" p-id="5157"></path><path d="M599.769816 782.53423l-43.856686 40.244295V511.943556c0-21.956565-18.28773-36.57546-36.575461-36.57546-21.956565 0-36.57546 18.28773-36.57546 36.57546v310.834969l-43.91313-40.244295c-14.618895-14.618895-40.244295-14.618895-54.86319 0-14.618895 14.618895-14.618895 36.57546 0 51.194356l109.726381 106.057546c3.668835 3.668835 7.337669 7.337669 10.950061 7.337669 14.618895 7.337669 29.237791 3.668835 40.244295-7.337669l106.057546-106.057546c14.618895-14.618895 14.618895-36.57546 0-51.194356-10.950061-14.618895-36.57546-14.618895-51.194356 0z" p-id="5158"></path></svg>
                    <span style="font-size: 12px !important;margin-left: 3px" v-html="item.name "></span>
                    <span v-if="itemFileType === item.value" class="checked">
                              <i style="position: absolute;font-weight: 700;top: 10px;left: -25px"
                                 class="el-icon-loading"></i>
                            </span>
                  </el-radio>
                </el-radio-group>

                <mapCanvas style="display: flex;justify-content: center;margin-top: 5px;"></mapCanvas>
                <el-button type="" v-if="showPlanSendButton&&showPlanSendButton!=''" class="Send-Sheceme" size="mini"
                           @click="sendPlan">发送方案给客户
                </el-button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <offerDetailPopup ref="offerPopup"></offerDetailPopup>
    <H5PlanIframe ref="h5PlanIframe"></H5PlanIframe>
    <tweet-image-dialog ref="tweetImage" class="tweet-image-dialog"></tweet-image-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import PlanApi from '@/components/Api/PlanApi'
import offerDetailPopup from '@/views/mechanism/components/offerDetailPopup'
import planMap from './planMap.vue'
import Qr from "@/components/Qr.vue";
import {mapState} from "vuex";
import H5PlanIframe from "@/components/H5PlanIframe.vue";
import TweetImageDialog from "@/views/plan/leftMoudle/dialog/tweetImageDialog.vue";
import mapCanvas from "@/components/MapCanvas.vue";

const programmeOptions = [0, 1, 2, 3, 8, 4, 5, 6, 7];
const offerOptions = [0, 1, 2];
// const h5Options = [0,1,2,3,4];
export default {
  name: '',
  components: {
    TweetImageDialog,
    Qr, offerDetailPopup, planMap, H5PlanIframe,mapCanvas
  },
  // 定义属性
  data() {
    return {
      exportContent: {
        // 团组报价单
        '0': {
          itemFileTypeArr: [
            {
              name: `请点击此处下载<span style="color: #339900">word</span>版本`,
              value: 0
            },
            {
              name: '请点击此处下载<span style="color: #339900">pdf</span>版本',
              value: 1
            },
            {
              name: '下载项目计划书<span style="color: #339900">excel</span>版本',
              value: 4
            },
            {
              name: '下载项目预算单<span style="color: #339900">excel</span>版本',
              value: 5
            }
          ]
        },
        // 团组确认书
        '1': {
          itemFileTypeArr: [
            {
              name: '请点击此处下载<span style="color: #339900">word</span>版本',
              value: 2
            },
            {
              name: '请点击此处下载<span style="color: #339900">pdf</span>版本',
              value: 3
            }
          ]
        },
        // 出团说明书
        '2': {
          itemFileTypeArr: [
            {
              name: '请点击此处下载<span style="color: #339900">word</span>版本',
              value: 6
            },
            {
              name: '请点击此处下载<span style="color: #339900">pdf</span>版本',
              value: 7
            }
          ]
        },
      },
      schemeShow: false,
      schemeRadio: 0,
      schemeData: [],
      left: 0,
      text: '',
      exportType: 0,
      // 特推图数量
      tweetCount: 0,
      checkItemContent: {
        programme: {
          checkAll: false,
          isIndeterminate: true,
          checkProgrammeItems: [4, 5, 6, 7, 8], // 默认就是有图文的
          programmeArr: programmeOptions
        },
        offer: {
          checkAll: false,
          isIndeterminate: true,
          checkOfferItems: [],
          offerArr: offerOptions
        }
      },
      itemFileType: -1,
      budgetFileName: ''
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapState(['budgetMainId', 'planId'])
  },
  // 监控data中的数据变化
  watch: {},
  props: {
    checkBudget: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showPlanSendButton: {
      type: String,
      default: '',
    }
  },
  // 方法集合
  methods: {
    getMyPlanBudgetName() {
      new PlanApi("plan").getPlanBudgetName(this.budgetMainId).then(res => {
        if (res.status === 200) {
          this.budgetFileName = res.data
        }
      })
    },
    sendPlan() {
      this.checkItemContent.schemeRadio = this.schemeRadio
      new PlanApi("plan").sendPlan(this.planId, JSON.stringify(this.checkItemContent)).then(res => {
        if (res.status == 200) {
          this.$message.success("发送成功")
        } else {
          this.$message.error(res.statusText)
        }
      }).catch(() => {
        this.$message.error("系统异常")
      })
    },
    goSet() {
      let doc = document.getElementsByClassName("planWordDialog")[0]
      doc.style.left = "25% !important"
      this.left = "25%"
      this.$refs.tweetImage.beforOpen(this.checkBudget);
    },
    preview() {
      if (this.text) {
        this.$refs.h5PlanIframe.open(this.text)
        let doc = document.getElementsByClassName("planWordDialog")[0]
        doc.style.left = "25% !important"
        this.left = "25%"
      }
    },
    listAddImage() {
      if (this.checkItemContent.programme.checkProgrammeItems.find(x => x === 5)) {
        new PlanApi("plan").listAddImage({budgetMainId: this.budgetMainId}).then(res => {
          if (res.status === 200) {
            this.tweetCount = res.data
          }
        })
      }
    },
    closeDialog() {
      this.schemeShow = false
      this.$emit("closeDialog")
    },
    handleCheckProgrammeAllChange(val) {
      this.checkItemContent.programme.checkProgrammeItems = val ? programmeOptions : [];
      this.checkItemContent.programme.isIndeterminate = false;
      this._builderQrCode()
    },
    handleCheckedProgrammeChange(value) {
      let checkedCount = value.length;
      this.checkItemContent.programme.checkAll = checkedCount === this.checkItemContent.programme.checkProgrammeItems.length;
      this.checkItemContent.programme.isIndeterminate = checkedCount > 0 && checkedCount < this.checkItemContent.programme.checkProgrammeItems.length;
      if (this.checkItemContent.programme.checkProgrammeItems.length === 0) {
        this.checkItemContent.programme.checkAll = false
      }
      this._builderQrCode()
    },
    handleCheckOfferAllChange(val) {
      this.checkItemContent.offer.checkOfferItems = val ? offerOptions : [];
      this.checkItemContent.offer.isIndeterminate = false;
      this._builderQrCode()
    },
    handleCheckedOfferChange(value) {
      // console.log("选择的值", value)
      //TODO  报价勾选单价全部钩上的逻辑有bug
      // let _find = value.find(x => x === 2)
      // if (_find && value.length > 0  ) {
      //         this.checkItemContent.offer.checkOfferItems = []
      //         this.checkItemContent.offer.checkOfferItems.push(0)
      //         this.checkItemContent.offer.checkOfferItems.push(1)
      //         this.checkItemContent.offer.checkOfferItems.push(2)
      // } else {
      let checkedCount = value.length;
      this.checkItemContent.offer.checkAll = checkedCount === this.checkItemContent.offer.checkOfferItems.length;
      this.checkItemContent.offer.isIndeterminate = checkedCount > 0 && checkedCount < this.checkItemContent.offer.checkOfferItems.length;
      if (this.checkItemContent.offer.checkOfferItems.length === 0) {
        this.checkItemContent.offer.checkAll = false
      }
      // }
      // this.checkItemContent.offer.checkOfferItems = Array.from(new Set(this.checkItemContent.offer.checkOfferItems));
      this._builderQrCode()
    },
    //跳转行程页面
    handlerOrganizationSetClick() {
      this.$router.push({
        name: 'organization',
        query: {
          currentComponent: 'organizationSet', //需要切换到那个组件
          organizationIsFun: true, //是否调用事件
          btns: '文字说明维护',
          btns1: '报价说明'

        }
      });
    },
    init() {
      this.schemeShow = true
      this._getData()
    },
    exportTypeChange(e) {
      if (this.exportType === 1) {
        this.checkItemContent.offer.checkOfferItems = []
        this.checkItemContent.offer.checkOfferItems.push(0)
        this.checkItemContent.offer.checkOfferItems.push(1)
        this.checkItemContent.offer.checkOfferItems.push(2)
      }
      this._builderQrCode()
      this._getData()
    },
    _getData() {
      new PlanApi("plan").queryByCompanyId(this.exportType).then(res => {
        if (res.status == 200) {
          this.schemeData = res.data
        }
      })
    },
    changeRadio(e) {
      e === this.schemeRadio ? this.schemeRadio = 0 : this.schemeRadio = e
      let _find = this.schemeData.find(x => x.id == e)
      if (_find && this.schemeRadio > 0) {
        this.$nextTick(() => {
          this.$refs.offerPopup.init(_find.htmlContentStr)
        })
        let doc = document.getElementsByClassName("planWordDialog")[0]
        doc.style.left = "25% !important"
        this.left = "25%"
        this._builderQrCode()
      } else {
        this.$refs.offerPopup.close()
      }
    },
    versionExport(e) {
      this.itemFileType = e
      if (this.itemFileType === 5) {
        this.checkItemContent.offer.checkOfferItems = []
        this.checkItemContent.offer.checkOfferItems.push(0)
        this.checkItemContent.offer.checkOfferItems.push(1)
        this.checkItemContent.offer.checkOfferItems.push(2)
        this._builderQrCode()
      }
      this.allowExport()
    },
    directExport() {
      this.schemeRadio = -1
      this.sureUseToWord()
    },
    allowExport() {
      this.$refs.offerPopup.close()
      let fileSuffix = '.pdf'
      if (this.itemFileType === 0 || this.itemFileType === 2) {
        fileSuffix = ".docx"
      }
      if (this.itemFileType === 4 || this.itemFileType === 5) {
        fileSuffix = ".xlsx"
      }
      let fileName = "";
      if (this.exportType === 0) {
        fileName = "团组报价单"
        if (this.itemFileType === 4) {
          fileName = "项目计划书"
        }
        if (this.itemFileType === 5) {
          fileName = "项目预算单"
        }
      }
      if (this.exportType === 1) {
        fileName = "团组确认书"
      }
      if (this.exportType === 2) {
        fileName = "出团说明书"
      }
      fileName = this.budgetFileName + " " +  fileName;
      this.exportDocument(fileName, fileSuffix)
    },

    exportDocument(fileName, fileSuffix) {
      new PlanApi("plan").exportPlanToWord(this.budgetMainId, this.schemeRadio, fileName, this.itemFileType, this.checkItemContent, fileSuffix, (e) => {
        if (e) {
          this.itemFileType = -1
        }
      }).then(res => {
        this.budgetFileName = ""
      }).catch(() => {
        this.$message.error("系统异常")
        // loading.close()
      })
    },
    sureUseToWord() {
      this.schemeShow = false
      this.allowExport()
    },
    _builderQrCode() {
      let checkItemContent = {
        programme: {
          checkProgrammeItems: this.checkItemContent.programme.checkProgrammeItems, // 默认就是有图文的
        },
        offer: {
          checkOfferItems: this.checkItemContent.offer.checkOfferItems,
        }
      }
      let uri = process.env["VUE_APP_COLLECTION_H5_SERVE"]
      let jsonObj = JSON.stringify(checkItemContent);
      uri = uri + `?programmeId=${this.schemeRadio}&type=1&budgetMainId=${this.budgetMainId}&planId=${this.planId}&priceDisplay=${encodeURIComponent(jsonObj)}`
      console.log("二维码链接", uri)
      this.text = uri
    },
    cancelShecma() {
      this.schemeRadio = -1
      this.$refs.offerPopup.close()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.listAddImage()
      this._builderQrCode()
      this.getMyPlanBudgetName(this.budgetMainId)
    })
  },
  beforeCreate() {
  }, // 生命周期 - 创建之前
  beforeMount() {
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
  }, // 生命周期 - 更新之前
  updated() {
  }, // 生命周期 - 更新之后
  beforeDestroy() {
  }, // 生命周期 - 销毁之前
  destroyed() {
  }, // 生命周期 - 销毁完成
  activated() {
  }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped lang="scss">
.tweet-image-dialog {
  z-index: 9999 !important;

  /deep/ .el-dialog {
    left: -20vw;
  }
}

.Item-File {
  display: flex;
  margin-top: 10px;
}

.Send-Sheceme {
  background-color: rgb(208, 74, 25);
  color: white;
  font-size: 14px;
  margin-top: 0.2rem;
}

.top-radio {
  display: flex !important;
  justify-content: space-between !important;
}

.Export-Item-File {
  background-color: white;
  border-radius: 10px;
  padding: 15px;

  /deep/ .Export-Item-Radio {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    justify-content: center;

  }
}

/deep/ .Export-Item-Radio {
  display: flex;
  //flex-direction: column;
  .is-checked {
    border-bottom: #DB4E1A 10px solid !important;
  }

  .el-radio {
    border-bottom: #C0C0C0 10px solid;
    display: flex;
    color: black;
    width: 160px;
    margin-right: 0;
    margin-top: 5px;
    padding-left: 5px;
    line-height: 3;
    //background-color: rgba(219, 78, 26, 0.4);
    //border: rgba(219, 78, 26, 0.4) 1px solid;
    .el-radio__input {
      display: none;
    }

    .el-radio__label {
      //color: black;
      opacity: 1;
      font-size: 14px !important;
      padding-left: 35px;
    }

    .checked {
      position: absolute;
      top: 0;
      right: 0;
      width: 12px;
      height: 12px;
      //background-color: rgba(219, 78, 26, 0.7);
      //border-radius: 0px 10px 0px 0px;
    }
  }
}

/deep/ .Export-Item-Radio-Download {
  display: flex;
  flex-direction: column;
  position: relative;
  top: -5px;
  //height: 100px;
  //overflow-y: scroll;

  .is-checked {
  }

  .el-radio {
    display: flex;
    color: black;
    width: 230px;
    margin-right: 0;
    margin-top: 5px;
    padding-left: 5px;
    line-height: 3;
    margin-bottom: 1px;
    margin-left: 20px;
    //background-color: rgba(219, 78, 26, 0.4);
    //border: rgba(219, 78, 26, 0.4) 1px solid;
    .el-radio__input {
      display: none;
    }

    .el-radio__label {
      //color: black;
      opacity: 1;
      width: 210px;
      padding-left: 15px;
      line-height: 1.6;
      font-size: 14px !important;
      box-shadow: 0px 3px 10px rgba(221, 221, 221, 0.9);
      border-radius: 25px;

      .el-icon-upload:before {
        font-size: 20px;
        padding-right: 10px;
        position: relative;
        top: 1px;
      }
    }

    .checked {
      position: absolute;
      top: 0;
      right: 0;
      width: 12px;
      height: 12px;
      //background-color: rgba(219, 78, 26, 0.7);
      //border-radius: 0px 10px 0px 0px;
    }
  }
}

.productTypeDialog {
  position: relative !important;
  left: var(--left);
  //  position: fixed;
  z-index: 3000 !important;

  /deep/ .Export-Item {
    display: flex;
    flex-direction: column;
  }

  /deep/ .el-dialog__body {
    margin-top: -11px;
  }

  .Dialog-top {
    display: flex;
    flex-direction: column;
    border-bottom: #C0C0C0 1px solid;
    padding-bottom: 10px;
    text-align: center;

    .schemeSharing {
      font-size: 16px;
      font-weight: 400;
      position: relative;
      left: -7px;
    }
  }

  .Radio-Before {
    margin-top: 10px;
    position: relative;
  }

  .Left-Line {
    border-left: #DB4E1A 1px solid;
    position: absolute;
    top: 56px;
    bottom: 74px;
  }

  .bigIcon {
    height: 30px;
    width: 30px;
    color: #DB4E1A;
    top: 50% !important;
    left: -34px !important;
  }

  .iconExport {
    position: absolute;
    left: -30px;
    top: -3px;
    display: inline-block;
    background: aliceblue;
  }

  .Bottom-Style {
    position: relative;
    top: 0;
    padding: 15px;
    background-color: rgba(221, 221, 221, 0.3);
    border-radius: 0px 0px 10px 10px;
  }

  .Button {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
  }

  .custom-radio {
    margin-top: 10px;
    padding-left: 2px;

    /deep/ .el-radio__label {
      display: inline-block;
      line-height: 16px;
      border-bottom: 1px solid #f39800;;
      padding: 0;
      margin-left: 10px;
    }

    /deep/ .el-radio {
      padding-bottom: 5px;
    }
  }
}

.cancelShecma {
  position: relative;
  top: 4px;
  left: 20px;
  color: rgb(219, 78, 26);
  display: inline-block;
  transform: scale(0.8);

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.checkBox {
  /deep/ .el-checkbox__inner {
    display: none;
    width: 14px;
    height: 14px;
  }

  /deep/ .el-checkbox__label {
    color: black !important;
    padding-bottom: 5px;
  }

  /deep/ .el-checkbox__label {
    padding-left: 0;
  }
}
</style>
